import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { attributesToProps, domToReactChildren, } from '@hellodarwin/core/lib/features/helpers/parse';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import message from 'antd/es/message';
import { useCallback } from 'react';
const GOOGLE_FILE_REGEX = /https:\/\/docs\.google\.com\/(?:document|spreadsheets)\/d\/([a-zA-Z0-9_-]+)/;
const useFormFillingGinRichTextParseOptions = ({ itemsById, copyFileToProgram, }) => {
    const { t } = useTranslations();
    const [messageApi, contextHolder] = message.useMessage();
    const getOnClick = useCallback((itemId, fileId) => async (e) => {
        var _a, _b, _c;
        let linkBehavior = 'copy';
        if (itemsById && ((_a = itemsById[itemId]) === null || _a === void 0 ? void 0 : _a.rich_text)) {
            linkBehavior =
                (_c = (_b = itemsById[itemId].rich_text) === null || _b === void 0 ? void 0 : _b.rich_text_link_behavior) !== null && _c !== void 0 ? _c : 'copy';
        }
        e.preventDefault();
        if (linkBehavior === 'open') {
            const linkElement = e.currentTarget;
            const href = linkElement.href;
            if (href) {
                window.open(href, '_blank');
            }
            return;
        }
        const key = `copy-doc-${fileId}`;
        try {
            messageApi.open({
                key,
                type: 'loading',
                content: t('gin_steps|opening_file_loading_message'),
                duration: 0,
            });
            const newFile = await copyFileToProgram(fileId);
            messageApi.open({
                key,
                type: 'success',
                content: t('gin_steps|file_opened_message'),
                duration: 2,
            });
            if (newFile.webViewLink) {
                window.open(newFile.webViewLink, '_blank');
            }
        }
        catch (err) {
            messageApi.open({
                key,
                type: 'error',
                content: t('gin_steps|failed_to_open_file_error_message'),
                duration: 2,
            });
            console.error('Failed to open file:', err);
        }
    }, [copyFileToProgram, messageApi, t, itemsById]);
    const getRichTextParseOptions = useCallback((itemId) => ({
        replace: (domNode) => {
            var _a;
            if (domNode.attribs && domNode.name === 'p') {
                const parseOpts = getRichTextParseOptions(itemId);
                return (_jsx(Typography, { elementTheme: "body2", children: domToReactChildren(domNode.children, parseOpts) }));
            }
            if (domNode.attribs && domNode.name === 'li') {
                const parseOpts = getRichTextParseOptions(itemId);
                return (_jsx("li", { children: _jsx(Typography, { elementTheme: "body2", children: domToReactChildren(domNode.children, parseOpts) }) }));
            }
            if (domNode.type === 'tag' &&
                domNode.name === 'a' &&
                ((_a = domNode.attribs) === null || _a === void 0 ? void 0 : _a.href)) {
                const href = domNode.attribs.href;
                const match = href.match(GOOGLE_FILE_REGEX);
                if (match) {
                    const fileId = match[1];
                    const parseOpts = getRichTextParseOptions(itemId);
                    return (_jsx("a", { href: href, onClick: getOnClick(itemId, fileId), children: domToReactChildren(domNode.children, parseOpts) }));
                }
            }
            if (domNode.attribs && domNode.name === 'a') {
                const props = attributesToProps(domNode.attribs);
                const parseOpts = getRichTextParseOptions(itemId);
                return (_jsx("a", Object.assign({}, props, { rel: "nofollow", target: "_blank", children: domToReactChildren(domNode.children, parseOpts) })));
            }
            return undefined;
        },
    }), [getOnClick]);
    return { getRichTextParseOptions, contextHolder };
};
export default useFormFillingGinRichTextParseOptions;
